import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,} from "@angular/core";
import {AgentDto} from "../../../../../feature-core/am/model/dto/entity/agent.dto";
import {AppointmentService} from "../../../service/api/appointment.service";
import {AppointmentTypeDto} from "../../../model/dto/entity/appointment-type.dto";
import {AppointmentTypeService} from "../../../service/api/appointment-type.service";
import {AsAppointmentLocationTypeInternal} from "../../../model/dto/entity/appointment.dto";
import {CustomerService} from "../../../../cr/service/api/customer.service";
import {AppointmentScheduleDto} from "../../../model/dto/entity/appointment-schedule-request.dto";
import {
    AppointmentTypeLocation,
    FreeSlot,
    Person,
    TransformedEventInterface
} from "../../../../../core/shared/scheduler/interfaces/scheduler.interface";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {MsCalendarEventDto} from "../../../../../feature-core/am/model/dto/api/ms/ms-calendar.types";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: "as-create-appointment",
    templateUrl: "as-creat-appointment.component.html",
    standalone: false
})
export class AsCreatAppointmentComponent
    implements OnInit, OnChanges {

    @Input() agents: AgentDto[];
    @Input() referenceObjectTypeAlias: string;
    @Input() referenceObjectTypeId: number;
    @Input() referenceObjectId: number;
    @Input() customerId: number;
    @Input() addressId: number;
    @Input() appointmentTypeId: number;
    @Input() appointmentTypeLocation: AsAppointmentLocationTypeInternal;
    @Input() selectedPeriod: { startTime: Date, endTime: Date }[];
    @Input() addressName: string;

    @Output() onEventClick: EventEmitter<TransformedEventInterface> = new EventEmitter();
    @Output() onAppointmentCreate: EventEmitter<MsCalendarEventDto> = new EventEmitter();


    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    startDate: Date = new Date(new Date().setHours(0, 0, 0, 0)); // Start of today (midnight)
    endDate: Date = new Date(new Date().setHours(23, 59, 59, 999)); // End of today (23:59:59)

    appointmentType: AppointmentTypeDto[];
    selectedAppointmentType: AppointmentTypeDto;
    createEventDialog: boolean;


    allFreeSlots: FreeSlot[];
    selectedFreeSlot: FreeSlot;


    selectedAgent: AgentDto;
    selectedSlotAgent: Person;
    additionalNotes: string;

    currentSelectionStart: Date;
    currentSelectionEnd: Date;

    isAudioCall: boolean = true;
    overwriteSlot: boolean;

    mode: 'NONE' | 'REALTIME' | 'OLD' = 'NONE'

    constructor(
        protected appointmentTypeService: AppointmentTypeService,
        protected customerService: CustomerService,
        protected appointmentService: AppointmentService) {
    }


    ngOnInit(): void {
        this.initComponent();
    }


    /**
     * Initialize Component.
     */
    initComponent() {
        this.getAppointmentTypes();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    handleCreateEvent() {

        if (!this.appointmentTypeId || !this.selectedAgent || !this.currentSelectionStart || !this.currentSelectionEnd) {
            return;
        }

        const payLoad: AppointmentScheduleDto = {
            appointmentTypeId: this.appointmentTypeId,
            agentId: this.selectedAgent.id,
            customerId: this.customerId,
            startDate: this.currentSelectionStart,
            endDate: this.currentSelectionEnd,
            comment: this.additionalNotes,
            isAudioCall: this.isAudioCall,
            addressId: this.addressId,
            referenceObjectTypeAlias: this.referenceObjectTypeAlias,
            referenceObjectTypeId: this.referenceObjectTypeId,
            referenceObjectId: this.referenceObjectId

        }

        this.appointmentService.scheduleAppointment(payLoad).subscribe(res => {
            this.onAppointmentCreate.emit(res);
            this.createEventDialog = false;
        });

    }

    getAppointmentTypes() {
        this.appointmentTypeService.list(ObjectRequestList.createBasic(false, [], [])).subscribe(response => {
            this.appointmentType = response.entries;
            this.handleAppointmentChange();
            this.refreshComponent();
        });
    }

    handleAppointmentChange() {
        this.selectedAppointmentType = this.appointmentType.find(type => type.id == this.appointmentTypeId);
    }


    handleAgentChange() {
        this.selectedAgent = this.agents.find((agent) => agent.id === this.selectedSlotAgent.id);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }

        this.initComponent();
    }


    protected readonly AsAppointmentLocationTypeInternal = AsAppointmentLocationTypeInternal;
    protected readonly AppointmentTypeLocation = AppointmentTypeLocation;
}

